import { ImageCropperComponent, ImageCroppedEvent } from 'ngx-image-cropper';
import { SafeUrl } from '@angular/platform-browser';
import { Component, CUSTOM_ELEMENTS_SCHEMA, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../../../components/icon/icon.component';
import { BtnComponent } from '../../../../components/btn/btn.component';
import { MatDialogRef } from '@angular/material/dialog';
import { UserdataService } from '../../../../service/userdata.service';


@Component({
    selector: 'app-avatar-edit',
    templateUrl: './avatar-edit.component.html',
    styleUrls: ['./avatar-edit.component.scss'],
    standalone: true,
    imports: [ImageCropperComponent, CommonModule, IconComponent, BtnComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AvatarEditComponent {
    imageChangedEvent: Event | null = null;
    croppedImage: SafeUrl = '';
    imageFile: File | undefined = undefined;
    showWrongFileType: boolean = false;
    hasAvatar: boolean = false;
    constructor(
        private dialogRef: MatDialogRef<AvatarEditComponent>,
        private userService: UserdataService
    ) { }

    ngOnInit() {
        const user = this.userService.data.getValue();
        this.hasAvatar = !!user?.avatar;
    }

    @HostListener('document:keydown.enter', ['$event'])
    onEnterKey(event: Event) {
        event.preventDefault();
        this.save();
    }
    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKey(event: Event) {
        event.preventDefault();
        this.close();
    }

    ngAfterViewInit() {
        console.log(this.imageChangedEvent, this.imageFile, this.croppedImage);
    }
    fileChangeEvent(event: Event): void {
        this.showWrongFileType = false;
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];

        if (!file) {
            return;
        }

        if (!file.type.match(/image\/*/)) {
            this.showWrongFileType = true;
            return;
        }

        this.imageFile = file;
        this.imageChangedEvent = event;
    }
    imageCropped(event: ImageCroppedEvent) {
        if (event.base64) {
            this.croppedImage = event.base64;
        }
    }
    onDragOver(event: any) {
        event.preventDefault();
    }
    onDropSuccess(event: any) {
        event.preventDefault();
        this.showWrongFileType = false;
        if (event.dataTransfer?.files?.length > 0) {

            if (event.dataTransfer.files[0].type.match(/image\/*/) == null) {
                this.showWrongFileType = true;
                return;
            }
            this.imageFile = event.dataTransfer.files[0];
            this.imageChangedEvent = new Event('fileSelected');
        }
    }
    close() {
        this.dialogRef.close();
    }
    save() {
        if (this.croppedImage) {
            this.userService.uploadAvatar(this.croppedImage).then((result) => {
                if (result) {
                    this.dialogRef.close();
                }
            });
        }
    }

    async removeAvatar() {
        const result = await this.userService.deleteAvatar();
        if (result) {
            this.dialogRef.close();
        }
    }

}

